import { addDays, getHours, getMinutes, isAfter, isSameDay, set, startOfDay } from "date-fns";

import { formatDate } from "@app/util/formatters";
import { parseTime } from "@app/util/parsers";

import SchedulePreset from "../enums/SchedulePreset";
import EmailSendingWindow from "../types/EmailSendingWindow";

import { getDefaultTodayTime } from "./getDefaultTodayTime";

export interface PresetOption {
  dateTime: Date;
  subtitle: string;
  value: SchedulePreset;
}

const getPresetDates = ({
  dateFormat,
  sendingWindow,
}: {
  dateFormat: string;
  sendingWindow: EmailSendingWindow;
}): PresetOption[] => {
  const today = startOfDay(new Date());
  const tomorrow = addDays(today, 1);
  const nextWeek = addDays(today, 7);

  const windowStart = parseTime(sendingWindow.startTime);
  const presets: PresetOption[] = [];

  const todayTime = getDefaultTodayTime(sendingWindow);
  const isTodayValid = isSameDay(todayTime, new Date());

  if (isTodayValid) {
    const windowEnd = parseTime(sendingWindow.endTime);
    const isWithinWindow = sendingWindow.endTime === "00:00" || !isAfter(todayTime, windowEnd);

    if (isWithinWindow) {
      presets.push({
        dateTime: set(today, { hours: getHours(todayTime), minutes: getMinutes(todayTime) }),
        subtitle: formatDate(today, dateFormat),
        value: SchedulePreset.TODAY,
      });
    }
  }

  presets.push(
    {
      dateTime: set(tomorrow, {
        hours: getHours(windowStart),
        minutes: getMinutes(windowStart),
      }),
      subtitle: formatDate(tomorrow, dateFormat),
      value: SchedulePreset.TOMORROW,
    },
    {
      dateTime: set(nextWeek, {
        hours: getHours(windowStart),
        minutes: getMinutes(windowStart),
      }),
      subtitle: formatDate(nextWeek, dateFormat),
      value: SchedulePreset.NEXT_WEEK,
    }
  );

  return presets;
};

export default getPresetDates;
